import BossModel from "@/models/BossModel";
import User from "@/models/User/User";

export default class Message extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'message';

    /**
     *
     * @type {string}
     */
    static entity = 'messages';

    static fields() {
		return {
			id: this.number(null).nullable(),
			title: this.attr(null),
			message: this.attr(null),
			user_id: this.number(null).nullable(),
			customer_id: this.number(null).nullable(),
			dossier_id: this.number(null).nullable(),
			task_id: this.number(null).nullable(),
			recipient_id: this.number(null).nullable(),
			invoice: this.boolean(false),
			read: this.boolean(false),
			archived: this.boolean(false),
			urgent: this.boolean(false),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            user_created: this.belongsTo(User, 'user_id'),
            user_recipient: this.belongsTo(User, 'recipient_id'),
		}
	}

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId){
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .get();
    }

    /**
     *
     * @param taskId
     * @param limit
     * @returns {*}
     */
    static loadByTask(taskId, limit = 0){
        return this.api()
            .where('task_id', taskId)
            .limit(limit)
            .get(false);
    }

    static countUnread() {
        return this.api()
            .action('unread/count')
            .getValue();
    }

    /**
     *
     * @returns {boolean|*}
     */
    User(){
        return this.getRelated('user_created');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Recipient(){
        return this.getRelated('user_recipient');
    }

    static toHtmlTitle(title) {
        if (!title) {
            return '';
        }

        let orderInfo = title.match("#(\\d*)");
        if (orderInfo) {
            let url = '<a href="'+'/vuetify/dossier/' + orderInfo[1] + '">' + orderInfo[0] + '</a>';
            return title.replace(orderInfo[0], url);
        }

        return title;
    }
}
